<template>
  <div class="container-fluid px-0" style="height: 600px" ref="vehicleTab">
    <div class="d-flex justify-content-between align-items-center pb-10 gap-5">
      <div class="d-flex gap-5">
        <div
          class="base-button base-button--action fsc-12 gap-5"
          style="height: 30px"
          @click="openCreateModal"
        >
          <img
            :src="require(`@/assets/icons/add.svg`)"
            width="13.5"
            height="13.5"
          />
          <span>Добавить</span>
        </div>
        <div
          class="base-button base-button--action fsc-12 gap-5"
          style="height: 30px"
          @click="openDeleteModal"
        >
          <img
            :src="require(`@/assets/icons/adddel.svg`)"
            width="13.5"
            height="13.5"
          />
          <span>Удалить</span>
        </div>
      </div>

      <div
        class="base-button base-button--action fsc-12 text-white"
        style="height: 30px; background: #00c8b3 !important"
        @click="openConfirmCreateServicesModal"
      >
        Внести в Обслуживание выбранные интервалы на пробеге 0
      </div>
    </div>

    <ve-table
      class="rest-style-table"
      style="width: 100%"
      :columns="columns"
      :table-data="dataTable"
      :border-x="true"
      :border-y="true"
      row-key-field-name="vehicle_interval_events__id"
      ref="mainTable"
      :checkbox-option="checkboxOption"
      :eventCustomOption="eventCustomOption"
      :clickHighlight="false"
      :rowStyleOption="{ hoverHighlight: true }"
      :cellSelectionOption="{ enable: false }"
      v-if="!localLoading"
    />

    <BaseModal
      name="intervalModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="!tw-bg-transparent !tw-shadow-none !tw-overflow-visible"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('intervalModal')"
        ></button>

        <div>
          <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
            Добавить/ Редактировать
          </div>

          <div>
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              class="tw-mb-[6px]"
              :value="inervalObjectForSend.vehicle_interval_events__name"
              :width="'200'"
              :horizontalTitle="true"
              @input="
                ({ value }) => {
                  inervalObjectForSend.vehicle_interval_events__name = value;
                }
              "
              name-sign="Название"
            >
            </BaseInputNew>
          </div>

          <div>
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              class="tw-mb-[6px]"
              :value="inervalObjectForSend.vehicle_interval_events__day"
              :width="'200'"
              :horizontalTitle="true"
              @input="
                ({ value }) => {
                  inervalObjectForSend.vehicle_interval_events__day = value;
                }
              "
              name-sign="Интервал дней"
            >
            </BaseInputNew>
          </div>

          <div>
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              class="tw-mb-[6px]"
              :value="inervalObjectForSend.vehicle_interval_events__km"
              :width="'200'"
              :horizontalTitle="true"
              @input="
                ({ value }) => {
                  inervalObjectForSend.vehicle_interval_events__km = value;
                }
              "
              name-sign="Интервал пробега"
            >
            </BaseInputNew>
          </div>

          <div>
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              class="tw-mb-[6px]"
              :value="inervalObjectForSend.vehicle_interval_events__motohour"
              :width="'200'"
              :horizontalTitle="true"
              @input="
                ({ value }) => {
                  inervalObjectForSend.vehicle_interval_events__motohour =
                    value;
                }
              "
              name-sign="Интервал моточасов"
            >
            </BaseInputNew>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('intervalModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="onSaveInterval"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="deleteIntervalModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="320"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('deleteIntervalModal')"
        ></button>
        <div>
          <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
            Удалить запись?
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('deleteIntervalModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="onDeleteInterval"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Удалить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptCreateIntervalsAtZero"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="380"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('acceptCreateIntervalsAtZero')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15" v-html="confirmMessage"></p>

          <div class="d-flex justify-content-center mt-15 gap-10">
            <div
              class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('acceptCreateIntervalsAtZero')"
            >
              Отменить
            </div>
            <div
              class="btn btn-sm px-20 btn-primary action-hover fsc-14 text-uppercase"
              @click="createIntervalsAtZero"
            >
              Подтвердить
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import EventBus from "@/event-bus";

const defaultIntervalObject = () => ({
  vehicle_interval_events__name: null,
  vehicle_interval_events__km: null,
  vehicle_interval_events__motohour: null,
  vehicle_interval_events__day: null,
  vehicle_interval_events__id: null,
});

export default {
  components: {
    VeTable,
  },
  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },
    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      submitting: false,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      inervalObjectForSend: defaultIntervalObject(),
      isEditOpenedModalInterval: false,
      eventCustomOption: {
        bodyRowEvents: ({ row }) => {
          return {
            dblclick: () => {
              this.onRowDblClick(row);
            },
          };
        },
      },
      checkboxOption: {
        hideSelectAll: false,
        selectedRowChange: ({ selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
        selectedAllChange: ({ selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
      },
    };
  },
  methods: {
    normalizeCellValue(field, value) {
      const numericFields = [
        "vehicle_interval_events__day",
        "vehicle_interval_events__km",
        "vehicle_interval_events__motohour",
      ];
      if (!numericFields.includes(field)) {
        return value;
      }

      if (value === null || value === undefined || value === "") {
        return null;
      }

      const numeric = Number(value);
      return Number.isNaN(numeric) ? null : numeric;
    },

    loadData() {
      this.$emit("loadingModal", true);
      this.localLoading = true;

      GeneralService.get(`/object_interval_events/${this.currentOpenedId}`)
        .then((data) => {
          this.dataTable = data.data.data.rows || [];
          this.activeSelectRowsMultiple = [];
        })
        .catch((e) => {
          this.$toast.error(
            e?.response?.data?.message ||
              "Неизвестная ошибка при загрузке таблицы",
            { duration: 5000 }
          );
        })
        .finally(() => {
          this.localLoading = false;
          this.$emit("loadingModal", false);
        });
    },

    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },

    openCreateModal() {
      this.isEditOpenedModalInterval = false;
      this.inervalObjectForSend = defaultIntervalObject();
      this.$modal.show("intervalModal");
    },

    openDeleteModal() {
      if (!this.activeSelectRowsMultiple.length) {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
        return;
      }
      this.$modal.show("deleteIntervalModal");
    },

    openConfirmCreateServicesModal() {
      if (!this.activeSelectRowsMultiple.length) {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
        return;
      }
      this.$modal.show("acceptCreateIntervalsAtZero");
    },

    createIntervalsAtZero() {
      GeneralService.editOrCreate(
        `/object_interval_events_plan/quick/${this.currentOpenedId}/${this.activeSelectRowsMultiple}`,
        {}
      )
        .then((data) => {
          this.$toast.success(data?.data?.message || "Сохранено", {
            duration: 5000,
          });
          this.$modal.hide("acceptCreateIntervalsAtZero");
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.message || "Ошибка", {
            duration: 5000,
          });
        });
    },

    onDeleteInterval() {
      if (!this.activeSelectRowsMultiple.length) {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
        return;
      }

      GeneralService.delete(
        `/object_interval_events/${this.currentOpenedId}/${this.activeSelectRowsMultiple}`
      )
        .then((data) => {
          this.$toast.success(data?.data?.message || "Удалено", {
            duration: 5000,
          });
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.message || "Ошибка удаления", {
            duration: 5000,
          });
        })
        .finally(() => {
          this.activeSelectRowsMultiple = [];
          this.$modal.hide("deleteIntervalModal");
          this.loadData();
        });
    },

    onSaveInterval() {
      this.submitting = true;
      const payload = {
        ...this.inervalObjectForSend,
        vehicle_interval_events__day: this.normalizeCellValue(
          "vehicle_interval_events__day",
          this.inervalObjectForSend.vehicle_interval_events__day
        ),
        vehicle_interval_events__km: this.normalizeCellValue(
          "vehicle_interval_events__km",
          this.inervalObjectForSend.vehicle_interval_events__km
        ),
        vehicle_interval_events__motohour: this.normalizeCellValue(
          "vehicle_interval_events__motohour",
          this.inervalObjectForSend.vehicle_interval_events__motohour
        ),
      };

      const request = this.isEditOpenedModalInterval
        ? GeneralService.edit(
            `/object_interval_events/${this.currentOpenedId}/${payload.vehicle_interval_events__id}`,
            payload
          )
        : GeneralService.editOrCreate(
            `/object_interval_events/${this.currentOpenedId}`,
            payload
          );

      request
        .then((data) => {
          this.inervalObjectForSend = defaultIntervalObject();
          this.isEditOpenedModalInterval = false;
          this.$toast.success(data?.data?.message || "Сохранено", {
            duration: 5000,
          });
          this.$modal.hide("intervalModal");
          this.loadData();
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.message || "Ошибка сохранения", {
            duration: 5000,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    onRowDblClick(row) {
      this.inervalObjectForSend = {
        vehicle_interval_events__id: row.vehicle_interval_events__id,
        vehicle_interval_events__name: row.vehicle_interval_events__name,
        vehicle_interval_events__km: row.vehicle_interval_events__km,
        vehicle_interval_events__motohour:
          row.vehicle_interval_events__motohour,
        vehicle_interval_events__day: row.vehicle_interval_events__day,
      };
      this.isEditOpenedModalInterval = true;
      this.$modal.show("intervalModal");
    },
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    confirmMessage() {
      return "Подтвердите создание выбранных <br/>интервальных событий на пробеге 0";
    },
    columns() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "vehicle_interval_events__name",
          key: "1",
          title: "Название",
          align: "center",
          width: "24.25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_interval_events__day",
          key: "2",
          title: "Интервал дней",
          align: "center",
          width: "24.25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_interval_events__km",
          key: "3",
          title: "Интервал пробега",
          align: "center",
          width: "24.25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_interval_events__motohour",
          key: "4",
          title: "Интервал моточасов",
          align: "center",
          width: "24.25%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
  },
  mounted() {},
};
</script>
